import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { IDataService, IParsedDataResponse } from '../../../../services/data/data-service.interface';
import { signsLocalization } from '../../../base-metric-card/helpers/base-metrics.helpers';
import { CONDITIONS_TRANSLATIONS } from '../../../../services/data/data-constants-translations';

@Component({
  selector: 'gtd-ui-field-default-conditions',
  templateUrl: './conditions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConditionsComponent {
  @Input() conditionsData: { field: string; operator: string; values: string[] }[];
  @Input() title: string;
  @Input() text: string = $localize`:@@common.show:Show`;
  public globalData: IParsedDataResponse;
  public booleanFields = new Set(['Is Approved', 'Is Test', 'Qualified', 'Manual Created', 'Is Late']);
  public signsLocalization = signsLocalization;
  public conditionsLocalization = CONDITIONS_TRANSLATIONS;

  constructor(@Inject('IDataService') private dataService: IDataService) {
    this.globalData = this.dataService.getData();
  }

  public getValueWithoutId(value: string): string {
    const index = value.indexOf(' / ');
    if (index === -1) {
      return value;
    }
    return value.substring(0, index);
  }
}
